import * as React from 'react';
import { AnimatePresence } from 'framer-motion';
import { useToast } from '@/context/ToastContext';
import { Toast } from './Toast';
import clsx from 'clsx';

/** Top-anchored toast stack. Mobile: top-center, desktop: top-right offset to clear the notification bell. */
export const ToastContainer: React.FC = () => {
  const { toasts, removeToast } = useToast();

  return (
    <div
      className={clsx(
        'pointer-events-none fixed z-toast flex flex-col gap-4',
        'inset-x-4 top-4 w-auto',
        'md:left-auto md:right-6 md:top-24 md:w-toast'
      )}
    >
      <AnimatePresence mode='popLayout'>
        {toasts.map((toast) => (
          <div key={toast.id} className='pointer-events-auto'>
            <Toast
              id={toast.id}
              title={toast.title}
              subtitle={toast.subtitle}
              icon={toast.icon}
              action={toast.action}
              secondaryAction={toast.secondaryAction}
              timestamp={toast.timestamp}
              onClose={removeToast}
            />
          </div>
        ))}
      </AnimatePresence>
    </div>
  );
};
